export default __webpack_public_path__ + "static/media/LFS_NT_POST1.4c82e988.png";